// This comes from checkout-sdk repo but it is not exported
// and with "isolatedModules" config on in chegg-web, we cannot
// import it from the "dist" directory like before
export var CheckoutStatus = /*#__PURE__*/function (CheckoutStatus) {
  CheckoutStatus["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
  CheckoutStatus["FAILED"] = "FAILED";
  CheckoutStatus["NOT_STARTED"] = "NOT_STARTED";
  CheckoutStatus["COMPLETED"] = "COMPLETED";
  CheckoutStatus["IN_PROGRESS"] = "IN_PROGRESS";
  return CheckoutStatus;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/interfaces.js
// module id = 4697
// module chunks = 11